export enum EGamePeriod {
  FIRST_HALF = 'FIRST_HALF',
  HALF_TIME = 'HALF_TIME',
  SECOND_HALF = 'SECOND_HALF',
  OVERTIME = 'OVERTIME',
  PENALTY_SHOOT_OUT = 'PENALTY_SHOOT_OUT',
}

export enum EStatusMatches {
  CANCELED = 'CANCELED',
  DELAYED = 'DELAYED',
  ENDED = 'ENDED',
  INTERRUPTED = 'INTERRUPTED',
  NORMAL = 'NORMAL',
  TO_BE_DEFINED = 'TO_BE_DEFINED',
  UPCOMING = 'UPCOMING',
}

export enum EIncidentsTeamGround {
  HOME = 'HOME',
  AWAY = 'AWAY',
  NEUTRAL = 'NEUTRAL',
}

export enum EIncidentsKind {
  KIND_UNSPECIFIED = 'KIND_UNSPECIFIED',
  GOAL = 'GOAL',
  CORNER = 'CORNER',
  OWN_GOAL = 'OWN_GOAL',
  YELLOW_CARD = 'YELLOW_CARD',
  RED_CARD = 'RED_CARD',
  CARD_UPGRADE = 'CARD_UPGRADE',
  SUBSTITUTION = 'SUBSTITUTION',
  PENALTY = 'PENALTY',
  VAR = 'VAR',
  START = 'START',
  MIDFIELD = 'MIDFIELD',
  END = 'END',
  PENALTY_MISSED = 'PENALTY_MISSED',
  OVERTIME_IS_OVER = 'OVERTIME_IS_OVER',
  PENALTY_KICK_ENDED = 'PENALTY_KICK_ENDED',
  EXTRA_TIME = 'EXTRA_TIME',
}

export enum EIncidentsVarResults {
  VAR_RESULT_UNSPECIFIED = 'VAR_RESULT_UNSPECIFIED',
  GOAL_CONFIRMED = 'GOAL_CONFIRMED',
  GOAL_CANCELED = 'GOAL_CANCELED',
  PENALTY_CONFIRMED = 'PENALTY_CONFIRMED',
  PENALTY_CANCELED = 'PENALTY_CANCELED',
  RED_CARD_CONFIRMED = 'RED_CARD_CONFIRMED',
  RED_CARD_CANCELED = 'RED_CARD_CANCELED',
  CARD_UPGRADE_CONFIRMED = 'CARD_UPGRADE_CONFIRMED',
  CARD_UPGRADE_CANCELED = 'CARD_UPGRADE_CANCELED',
  ORIGINAL_DECISION = 'ORIGINAL_DECISION',
  ORIGINAL_DECISION_CHANGED = 'ORIGINAL_DECISION_CHANGED',
  OTHER = 'OTHER',
}
